<p-panelMenu [model]="items" [multiple]="false"></p-panelMenu>
